export const eulaContent = `
**End-User License Agreement (EULA)**

**Effective Date:** 12.09.2026

**PLEASE READ THIS AGREEMENT CAREFULLY BEFORE USING THIS APPLICATION. BY ACCESSING OR USING THIS APPLICATION, YOU AGREE TO BE BOUND BY THE TERMS OF THIS AGREEMENT. IF YOU DO NOT AGREE TO THESE TERMS, DO NOT USE THE APPLICATION.**

---

### 1. **Introduction**
This End-User License Agreement ("Agreement") is a legal agreement between you ("User") and FoodPlanner ("Company," "we," or "us") for the use of the FoodPlanner ("Application").

### 2. **License Grant**
We grant you a limited, non-exclusive, non-transferable, and revocable license to use the Application for personal, non-commercial purposes, subject to the terms of this Agreement.

### 3. **Restrictions**
You agree that you will not:
- Copy, modify, distribute, or create derivative works based on the Application or any part of it without prior written permission.
- Reverse-engineer, decompile, or disassemble the Application.
- Use the Application to violate any laws or regulations.
- Rent, lease, or sublicense the Application.

### 4. **User Data and Privacy**
Your use of the Application is subject to our [Privacy Policy](/privacy), which explains how we collect, use, and store your data. By using the Application, you consent to the terms of our Privacy Policy.

### 5. **Intellectual Property**
All intellectual property rights in the Application, including but not limited to code, designs, text, and trademarks, are owned by the Company. Unauthorized use of any intellectual property is strictly prohibited.

### 6. **Prohibited Actions**
You may not:
- Attempt to circumvent security features of the Application.
- Use the Application to create or share harmful, defamatory, or unlawful content.

### 7. **Termination**
We reserve the right to terminate this Agreement and your access to the Application at any time if you violate its terms. Upon termination, you must stop all use of the Application and delete any copies in your possession.

### 8. **Disclaimer of Warranties**
The Application is provided "as is" without any warranties, express or implied, including but not limited to warranties of merchantability, fitness for a particular purpose, or non-infringement. We do not guarantee that the Application will be error-free or available at all times.

### 9. **Limitation of Liability**
To the maximum extent permitted by law, we shall not be liable for any damages arising out of or related to your use of or inability to use the Application, including but not limited to direct, indirect, incidental, or consequential damages.

### 10. **Indemnification**
You agree to indemnify and hold us harmless from any claims, damages, or expenses arising from your use of the Application or violation of this Agreement.

### 11. **Governing Law**
This Agreement shall be governed by and construed in accordance with the laws of Rogaland, Norway.

### 12. **Amendments**
We reserve the right to modify this Agreement at any time. If we make material changes, we will notify you by posting an updated version in the Application or through other means. Your continued use of the Application after changes become effective constitutes your acceptance of the modified terms.

### 13. **Contact Information**
For questions or concerns about this Agreement, please contact us at:
- Email: foodplannerio@gmail.com
- Address: Rogaland, Norway

---

By clicking "Agree" or using the Application, you acknowledge that you have read, understood, and agreed to be bound by this Agreement.
`;
